import { State } from './typings'

export const initialState: State = {
  loading: false,
  serviceLocations: [],
  shouldRedirect: false,
  selectedServiceLocations: new Map(),
}
